import { makeStyles } from '@material-ui/core/styles';

export const useDrawerStyles = makeStyles(theme => ({
  aiAssistantContainer: {
    backgroundColor: theme.palette.grey[100],
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: 350,
    minWidth: 280,
    overflow: 'auto',
    width: '100%'
  },
  drawerLarge: {
    width: '85vw',
    maxWidth: 1600,
    [theme.breakpoints.only('md')]: {
      width: '90vw'
    },
    [theme.breakpoints.only('sm')]: {
      width: '92vw'
    },
    [theme.breakpoints.only('xs')]: {
      width: '95vw'
    }
  },
  dualContainers: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    minHeight: 0,
    position: 'relative',
    width: '100%'
  },
  rightContainer: {
    flexGrow: 1,
    minWidth: 0,
    overflowY: 'auto'
  }
}));
